import { render } from "./UserDeleteModal.vue?vue&type=template&id=59542f58"
import script from "./UserDeleteModal.vue?vue&type=script&lang=js"
export * from "./UserDeleteModal.vue?vue&type=script&lang=js"
script.render = render

export default script